import MaintenanceLilSolid from "./MaintenanceLilSolid";
export default MaintenanceLilSolid;